import { TProductId } from 'models/subscriptions.model'

import { ScreenName, eventLogger } from 'services/eventLogger.service'

import { PaymentMethod, PaymentSystem, StripeErrorCode } from '../constants'

export const logFailedPayment = ({
  email,
  productId,
  priceDetails,
  paymentResponse: { type, code, message, decline_code: declineCode },
  paymentMethod,
  screenName,
  paymentSystem,
  stripeAccountName,
  stripeAccountId,
  isPersonalDataAllowed,
}: {
  email: string
  productId: TProductId
  priceDetails: { price: number; trial?: boolean; currency?: string }
  paymentResponse: {
    type: string
    code?: string
    message?: string
    decline_code?: string
  }
  paymentMethod: PaymentMethod
  screenName: ScreenName
  paymentSystem: PaymentSystem
  stripeAccountName?: string
  stripeAccountId?: string
  isPersonalDataAllowed: boolean
}): void => {
  const errorCode =
    code === StripeErrorCode.CARD_DECLINED ? `${code}:${declineCode}` : code

  eventLogger.logPurchaseFailed({
    email,
    productId,
    priceDetails,
    error: { type, code: errorCode, description: message },
    paymentMethod,
    screenName,
    paymentSystem,
    stripeAccountName,
    stripeAccountId,
    isPersonalDataAllowed,
  })
}
